import { observer } from "mobx-react";
import ReturnMethodStore from "../../../../stores/return-method-store";
import FormFieldLineLayout from "../../../../../../components/layouts/form-field-line-layout/form-field-line-layout";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Toggle } from "../../../../../../components/inputs/toggle/toggle";
import { SelectDropdownGrouped } from "../../../../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import { NOTE_TYPE, Note } from "../../../../../../components/note/note";
import IconLocation from "../../../../../../components/icons/icon-location/icon-location";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import AddressNote from "../address-note/address-note";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import { DROP_OFF_LOCATION } from "../../../../constants";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface Props{
    returnMethod: ReturnMethodStore;
    validationGroup: IValidationGroup;
}

const RestockingLocationsFields: React.FC<Props> = observer(({ returnMethod, validationGroup }: Props) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';
    
    const restockingLocationList = returnMethod.getRestockingLocationsList(getTranslation);
    const selectedRestockingLocation = restockingLocationList.map(category => category.options).flat().find(option => option.value === returnMethod.shopifyRestockLocationId);

    return(
        <FormFieldLineLayout>
            
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                {getTranslation("RESTOCKING_LOCATION", scope)}
            </FontBody2>

            { returnMethod.showRestockAtThisAddress() &&
                <FormFieldLine label={getTranslation("RESTOCKING_AT_SELECTED_RETURN_ADDRESS", scope)}>
                    <Toggle 
                        checked={returnMethod.restockAtThisAddress}
                        label="" 
                        onChange={v => {returnMethod.setRestockAtThisAddress(v)}}
                        disabled={false}
                    />
                </FormFieldLine>
            }
            
            { !(returnMethod.showRestockAtThisAddress() && returnMethod.restockAtThisAddress)  &&
            <>
                <FormFieldLine
                    label={getTranslation("DEFAULT_RESTOCKING_LOCATION", scope)}
                    note={getTranslation("DEFAULT_RESTOCKING_LOCATION_NOTE", scope)}
                    required={true}
                >
                    <SelectDropdownGrouped 
                        options={restockingLocationList}
                        value={selectedRestockingLocation}
                        onChange={(v) => returnMethod.setShopifyRestockLocationId(v?.value as string)}
                        required
                        validationGroup={validationGroup}
                    />
                </FormFieldLine>
                { returnMethod.shopifyRestockLocationId === DROP_OFF_LOCATION.FULFILLMENT_LOCATION ?
                    <FormFieldLine label="">
                        <Note
                        type={NOTE_TYPE.INFORMATION}
                        IconComponent={IconLocation}
                        body= {
                            <FontBody2>
                                {getTranslation("DEFAULT_RESTOCKING_LOCATION_NOTE_2", scope)}
                            </FontBody2>
                        }
                        />
                    </FormFieldLine>
                    :
                    <AddressNote address={returnMethod.getLocation(returnMethod.shopifyRestockLocationId)} />
                }
            </>
            }
            
        </FormFieldLineLayout>
    )
});

export default RestockingLocationsFields;